
import { articleRedirects } from "./articleRedirectsData";
import { isAdmin as checkIsAdmin } from "@/services/authService";
import { getRedirects, createRedirect } from "@/services/redirectService";

export const importArticleRedirects = async () => {
  console.log('Starting import of article redirects...');
  
  try {
    const isAdmin = await checkIsAdmin();
    if (!isAdmin) {
      throw new Error('User must be logged in to import redirects');
    }
    
    // Check if any redirects already exist
    const existingRedirects = await getRedirects();
    const existingPathsSet = new Set(existingRedirects.map(r => r.source_path));
    
    // Filter out redirects that already exist
    const newRedirects = articleRedirects.filter(
      redirect => !existingPathsSet.has(redirect.source_path)
    );
    
    if (newRedirects.length === 0) {
      console.log('All redirects already exist');
      return { success: articleRedirects.length, failed: 0, message: 'All redirects already exist' };
    }
    
    // Insert redirects in batches of 50
    const batchSize = 50;
    let successful = 0;
    let failed = 0;
    
    for (let i = 0; i < newRedirects.length; i += batchSize) {
      const batch = newRedirects.slice(i, i + batchSize);
      try {
        await Promise.all(batch.map((redirect) => createRedirect({
          ...redirect,
          status_code: redirect.status_code as 301 | 302 | 307 | 308,
        })));
        successful += batch.length;
      } catch (error) {
        console.error('Error inserting batch:', error);
        failed += batch.length;
      }
    }
    
    console.log(`Import complete. Successful: ${successful}, Failed: ${failed}`);
    return { 
      success: successful, 
      failed: failed, 
      message: `Imported ${successful} redirects${failed > 0 ? `, ${failed} failed` : ''}` 
    };
    
  } catch (error) {
    console.error('Error importing article redirects:', error);
    throw error;
  }
};
